<template>
    <div>
        <Breadcrumb />
        <div class="container">
            <div class="container-box">
                <div class="container-l">
                    <!--新样式S-->
                    <div class="container-top">
                        <h1 class="container-top-title">{{contentFotm(detailsData.tilte)}} </h1>
                        <p class="laiyuan">
                            <span style="padding-right:10px">{{detailsData.createTime}}</span>
                            <span>Source：</span><span>{{ detailsData.source }}</span>
                        </p>
                        <ul class="fj-list">
                            <li v-for="(item, index) in detailsData.fileInfo" :key="index">
                                <div class="down-btn" @click="downBtn(item, detailsData)"><img src="@/assets/images/download.png" alt="" class="down-icon">下载附件{{ index + 1 }}</div>
                                <div class="down-title">{{ index + 1 }}.{{ item.fileName }}</div>
                            </li>
                        </ul>
                    </div>
                    <div class="container-bottom">
                        <UnfurlAndFoldBG title="Brief Introduction" class="grou">
                            <p class="textIndent">{{ contentFotm(detailsData.introduction) }}</p>
                        </UnfurlAndFoldBG>
                        <UnfurlAndFoldBG title="Text" class="grou">
                            <div class="content line-feed editorStyle" v-html="contentFotm(detailsData.richTextEditor)"></div>
                        </UnfurlAndFoldBG>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { htmlRestore, htmlString } from "@/utils/htmlRestore.js";
import Breadcrumb from "@/components/Breadcrumb";
import { download } from "@/api/common.js";
import { downloadFile } from "@/utils/download.js";
import UnfurlAndFoldBG from "@/components/UnfurlAndFoldBG.vue";
import { ttIndustryInformationEnglishDetails } from "@/api/index.js";
export default {
    name: "Vcontent",
    components: {
        Breadcrumb,
        UnfurlAndFoldBG,
    },
    data() {
        return {
            detailsData:{}
        };
    },
    created(){
        let id = this.$route.query.id
        console.log(id)
        this.ttIndustryInformationEnglishDetails(id)
    },
    methods: {
        ttIndustryInformationEnglishDetails(id){
            ttIndustryInformationEnglishDetails(id).then(res=>{
                    if (res.code == 200) {
                        this.detailsData = res.data
                    }
            })
        },
        splitArr(data) {
            if (data && data.length > 0) {
                return data.split(",");
            } else {
                return [];
            }
        },
        contentFotm(data) {
            if (data) {
                return htmlRestore(data);
            }
        },
        downBtnYc() {
            let self = this;
            download({
                fileUrl: this.detailsData.attachUrl,
                articleId: this.detailsData.id,
            }).then((res) => {
                var reader = new FileReader();
                reader.readAsText(res);
                reader.addEventListener("loadend", function (e) {
                    try {
                        JSON.parse(e.target.result);
                        let msg = JSON.parse(e.target.result);
                        self.$message({
                            showClose: true,
                            message: msg.message,
                            type: "error",
                        });
                    } catch (err) {
                        downloadFile(res, self.detailsData.acctachName);
                    }
                });
            });
        },
        downBtns() {
            let self = this;
            download({
                fileUrl: this.detailsData.attachUrl,
                articleId: this.detailsData.standardContentId,
            }).then((res) => {
                var reader = new FileReader();
                reader.readAsText(res);
                reader.addEventListener("loadend", function (e) {
                    try {
                        JSON.parse(e.target.result);
                        let msg = JSON.parse(e.target.result);
                        self.$message({
                            showClose: true,
                            message: msg.message,
                            type: "error",
                        });
                    } catch (err) {
                        downloadFile(res, self.detailsData.acctachName);
                    }
                });
            });
        },
        //下载
        downBtn(item, obj) {
            let self = this;
            download({ fileUrl: item.url, articleId: obj.id }).then((res) => {
                var reader = new FileReader();
                reader.readAsText(res);
                reader.addEventListener("loadend", function (e) {
                    try {
                        JSON.parse(e.target.result);
                        let msg = JSON.parse(e.target.result);
                        self.$message({
                            showClose: true,
                            message: msg.message,
                            type: "error",
                        });
                    } catch (err) {
                        downloadFile(res, item.fileName);
                    }
                });
            });
        },
    },
};
</script>
<style lang="less" scoped>
.container {
    width: 100%;
    padding-right: 15px;
    padding-top: 15px;
    .container-box {
        width: 100%;
        display: flex;
        align-items: flex-start;
    }
    .container-l{
        flex: 1;
    }
    .container-tag {
        margin-bottom: 10px;
        margin-left: -10px;
        .tags {
            margin-left: 10px;
        }
    }
    .container-title {
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
        color: #333;
        margin-bottom: 10px;
    }
    .container-summary,
    .container-tip {
        font-size: 16px;
        line-height: 24px;
        color: #828282;
    }
    .container-summary {
        margin-bottom: 16px;
    }
    .container-tip {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .container-tip-l {
            span {
                padding-right: 15px;
            }
        }
    }
}

.fj {
    font-size: 13px;
    line-height: 13px;
    color: #828282;
}

.editorStyle {
    border-radius: 2px;
    padding: 20px;
    /deep/ p {
        font-size: 16px;
        margin-bottom: 20px;
        text-indent: 2em;
        text-align: justify;
        img {
            max-width: 100%;
            height: auto;
            margin-left: -2em;
        }
    }
    
 /deep/ p, /deep/ ul, /deep/ menu, /deep/ dir,/deep/ h3{
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  /deep/ h1{
    font-weight: bold ;
    font-size: 32px ;
    margin: 21px 0 ;
  }
  /deep/ h2{
    font-weight: bold ;
    font-size: 24px ;
    margin: 19px 0 ;
  }
 /deep/  h3{
    font-weight: bold ;
    font-size: 19px ;
    margin: 18px 0 ;
  }
 /deep/  h4{
    font-weight: bold ;
    font-size: 16px ;
    margin: 21px 0 ;
  }
 /deep/  h5{
    font-weight: bold ;
    font-size: 13px ;
    margin: 22px 0 ;
  }
 /deep/  h6{
    font-weight: bold ;
    font-size: 11px ;
    margin: 24px 0 ;
  }
 /deep/  option{
    padding: 0px 2px 1px;
  }
 /deep/  input{
    padding: 1px;
  }
  /deep/ fieldset{
    margin-inline-start: 2px;
    margin-inline-end: 2px;
    padding-block-start: 0.35em;
    padding-inline-start: 0.75em;
    padding-inline-end: 0.75em;
    padding-block-end: 0.625em;
  }
 /deep/  textarea{
    padding: 2px;
  }
 /deep/  legend{
    padding-inline-start: 2px;
    padding-inline-end: 2px;
  }
 /deep/  a{
    text-decoration: underline;
    color: #4182fa;
  }
  /deep/ ul{
    padding-left: 40px ;
    padding-right: 40px ;
    list-style: disc;
  }
 /deep/  ol{
    list-style: decimal;
    padding-left: 40px ;
    padding-right: 40px ;
  }
  /deep/ li{
    display: list-item ;
    list-style: disc;
  }
 /deep/  strong{
      font-weight: bold;
  }

}
.xgtj-box {
    background: #fff;
    min-height: 200px;
    h1 {
        width: 100%;
        background: #fff;
        border-radius: 4px;
        padding: 0 16px;
        color: #0d57bc;
        padding: 15px;
        font-size: 16px;
        font-weight: bold;
        line-height: 16px;
    }
}
.zwtj {
    text-align: center;
    line-height: 150px;
}

//新样式S
.container-top {
    background: #fff;
    padding: 0 16px 24px;
    margin-bottom: 12px;
    .container-top-title {
        font-weight: bold;
        font-size: 24px;
        line-height: 33px;
        color: #333;
        padding-left: 16px;
        padding-top: 32px;
        padding-bottom: 24px;
    }
    .bh {
        display: inline-block;
        padding: 10px 8px 10px 16px;
        background: #f4f5f6;
        border-radius: 2px;
        margin-bottom: 14px;
        span {
            font-weight: bold;
            font-size: 16px;
            line-height: 16px;
            color: #333;
        }
    }
    .time {
        font-size: 14px;
        line-height: 20px;
        color: #4f4f4f;
    }
    .laiyuan {
        padding-left: 16px;
        font-size: 16px;
        line-height: 16px;
        color: #4f4f4f;
        margin-bottom: 24px;
    }
    .down-btn {
        display: inline-block;
        padding: 7px 12px;
        font-size: 12px;
        line-height: 12px;
        background: #0d57bc;
        border-radius: 2px;
        border-color: #0d57bc;
        color: #fff;
        cursor: pointer;
        .down-icon {
            vertical-align: sub;
        }
    }
    .fj-list li {
        display: flex;
        margin-bottom: 8px;
    }
    .down-title {
        flex: 1;
        position: relative;
        font-size: 13px;
        line-height: 31px;
        color: #333;
        margin-left: 12px;
        &::after {
            display: block;
            content: "";
            position: absolute;
            width: 100%;
            bottom: -4px;
            left: 0;
            border-bottom: 1px solid #f2f2f2;
        }
    }
    .fj-list li:last-child {
        margin-bottom: 0px;
    }
    .fj-list li:last-child .down-title::after {
        display: none;
    }
}
.container-bottom {
    background: #fff;
    padding: 36px 16px 16px;
    .grou {
        font-size: 16px;
        line-height: 32px;
        color: #333;
        margin-bottom: 20px;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
//新样式E
</style>